import dayjs from 'dayjs';
// constants
import ConfirmStatus from '../../../constants/legal_check_confirm/confirm_status';
import LevelColorEnum from '../../../constants/review/level_color.js';
import AdviceTargetType from '../../../constants/legal_check/advice_target_type';

// No Test Created
export function isArrayBlank(listData) {
  return !listData || !Array.isArray(listData) || !listData.length > 0;
}
// No Test Created
export function getCheckResultJson(legalCheckAdviceList, checkResultList) {
  let checkResult = {};
  legalCheckAdviceList.forEach((jouAdvice, _) => {
    jouAdvice.adviceList.forEach((advice, _) => {
      checkResult[advice.adviceIndex] = !!(
        !isArrayBlank(checkResultList) &&
        checkResultList.filter(legalCheckConfirmData => {
          return (
            legalCheckConfirmData.legalCheckMethodId === advice.legalCheckMethodId &&
            legalCheckConfirmData.confirmStatus === ConfirmStatus.CONFIRMED.value
          );
        }).length
      );
    });
  });
  return checkResult;
}

// Test Created
export function getListOfMethodType(legalCheckAdviceList) {
  return legalCheckAdviceList
    .filter(list => list.adviceList.length > 0)
    .flatMap(list => list.adviceList)
    .map(advice => advice.methodType);
}

// Test Created
export function createExpendablePanelCardAdviceIndexList(legalCheckAdviceList) {
  let output = [];
  if (isArrayBlank(legalCheckAdviceList)) {
    return output;
  }
  legalCheckAdviceList
    .filter(list => list.adviceList.length > 0)
    .forEach(list => {
      if (list.isMissingType) {
        list.adviceList.forEach(advice => {
          output.push([advice.adviceIndex]);
        });
      } else {
        output.push(list.adviceList.flatMap(list => list.adviceIndex));
      }
    });
  return output;
}

// Test Created
export function createExpendablePanelCardList(legalCheckAdviceList) {
  let output = [];
  if (isArrayBlank(legalCheckAdviceList)) {
    return output;
  }
  legalCheckAdviceList
    .filter(list => list.adviceList.length > 0)
    .forEach(list => {
      if (list.isMissingType) {
        list.adviceList.forEach(advice => {
          output.push({
            adviceList: [advice],
            isMissingType: list.isMissingType,
            index: list.index,
            adviceTargetType: list.adviceTargetType,
            messageTypeList: list.messageTypeList
          });
        });
      } else {
        output.push({
          adviceList: list.adviceList.flatMap(list => list),
          isMissingType: list.isMissingType,
          index: list.index,
          adviceTargetType: list.adviceTargetType,
          messageTypeList: list.messageTypeList
        });
      }
    });
  return output;
}

// Test Created
export function findIndexFromExpendablePanelCardList(list, adviceIndex) {
  let outputIndex = 0;
  for (const [index, adviceIndices] of list.entries()) {
    if (adviceIndices.includes(adviceIndex)) {
      outputIndex = index;
      break;
    }
  }
  return outputIndex;
}

export function getColorByLevel(level) {
  if (LevelColorEnum.Level0.value === level) {
    return LevelColorEnum.Level0.css;
  }
  if (LevelColorEnum.Level1.value === level) {
    return LevelColorEnum.Level1.css;
  }
  if (LevelColorEnum.Level2.value === level) {
    return LevelColorEnum.Level2.css;
  }
  if (LevelColorEnum.Level3.value === level) {
    return LevelColorEnum.Level3.css;
  }
  if (LevelColorEnum.Level4.value === level) {
    return LevelColorEnum.Level4.css;
  }
  if (LevelColorEnum.Level5.value === level) {
    return LevelColorEnum.Level5.css;
  }

  return '';
}

// No Test Created
export function getContractPartyName(contractParties) {
  let contractPartyNames = [];
  for (let i = 0; i < contractParties.length; i++) {
    contractPartyNames.push(contractParties[i].contractPartyName);
  }
  return contractPartyNames;
}

export function getOpenReviewContractProperties() {
  const properties =
    'width=961,height=' +
    window.innerHeight +
    ',left=' +
    (window.screenX + window.innerWidth - 961) +
    ',top=' +
    (window.screenTop + 50) +
    ',directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,';
  return properties;
}

export function getCurrentDateTimeText() {
  return dayjs(new Date()).format('YYYYMMDDHHmm');
}

export function getDownloadFileName(fileName, adviceTitle, extension = '.docx') {
  if (!fileName) {
    fileName = '無題のファイル';
  }
  return `${
    fileName.split('.').length > 1
      ? fileName
          .split('.')
          .slice(0, -1)
          .join('.')
      : fileName
  }_${adviceTitle}_${getCurrentDateTimeText()}${extension}`;
}

// Test Created
export function prepareAdvicesToPrint(adviceList, bodyList) {
  adviceList = JSON.parse(JSON.stringify(adviceList));
  return adviceList.map(advice => {
    if (!advice.isMissingType) {
      if (advice.adviceTargetType === AdviceTargetType.OVER_ALL.value) {
        advice.jouban = '契約書全体に関する指摘';
        advice.joutitle = '';
        advice.enJoutitle = '';
      } else if (advice.adviceTargetType === AdviceTargetType.BEGIN.value){
        advice.jouban = '前文';
        advice.joutitle = '';
        advice.enJoutitle = '';
      } else if (advice.adviceTargetType === AdviceTargetType.END.value) {
        advice.jouban = '後文';
        advice.joutitle = '';
        advice.enJoutitle = '';
      } else {
        advice.jouban = bodyList[advice.index].jouban;
        advice.joutitle = bodyList[advice.index].joutitle;
        advice.enJoutitle = bodyList[advice.index].enJoutitle;
      }
    }

    return advice;
  });
}

// Test Created
export function prepareTemplatesToPrint(templateList, bodyList) {
  templateList = JSON.parse(JSON.stringify(templateList));
  return templateList.map((templates, index) => {
    const userContract = index < bodyList.length ? bodyList[index] : null;
    return {
      jouban: userContract ? bodyList[index].jouban : null,
      joutitle: userContract ? bodyList[index].joutitle : null,
      enJoutitle: userContract ? bodyList[index].enJoutitle : null,
      joubun: userContract ? bodyList[index].joubun : null,
      enJoubun: userContract ? bodyList[index].enJoubun : null,
      templateList: templates
    };
  });
}

// Test Created
export function filterDataByPrioritySettingsFilter(data, PrioritySettingsFilter) {
  let copiedData = JSON.parse(JSON.stringify(data));

  function compareFilter(advice) {
    const priority = advice.companyPriority ? advice.companyPriority : advice.defaultPriority;
    return priority <= PrioritySettingsFilter;
  }

  copiedData.forEach((item, _) => {
    const filterdAdviceList = item.adviceList.filter(advice => compareFilter(advice));
    item.adviceList = filterdAdviceList;
  });
  let missinIndex = 1;
  let modifyIndex = 1;
  copiedData.forEach((item, _) => {
    item.adviceList.forEach((advice, _) => {
      if (item.isMissingType) {
        advice.badgeNumber = missinIndex;
        missinIndex++;
      } else {
        advice.badgeNumber = modifyIndex;
        modifyIndex++;
      }
    });
  });
  return copiedData;
}



// WEBPACK FOOTER //
// ./src/functions/pages/review_contract/index.js